import Link from "next/link";
import { Icon } from "@iconify/react";
import { HeroPreview } from "./HeroPreview";

export function HeroSection() {
  return (
    <section className="relative py-12 sm:py-20 lg:py-24">
      <div className="grid items-center gap-14 xl:grid-cols-12 xl:gap-10">
        <div className="xl:col-span-5">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-[#2B3624]/10 bg-white/50 px-3 py-1.5 text-xs font-medium uppercase tracking-wider text-[#66705F]">
            <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-[#7C8D52]" />
            AI workspace for real team collaboration
          </div>

          <h1 className="max-w-2xl text-4xl font-normal leading-[1.05] tracking-tight text-[#2B3624] sm:text-6xl lg:text-7xl">
            Turn every conversation into organized work.
          </h1>

          <p className="mt-7 max-w-xl text-base leading-relaxed text-[#4B5563] sm:text-lg">
            CollaboratorX brings chat, video calls, workspace knowledge, decisions, tasks, and AI into one
            shared workspace. Your team talks. CollaboratorX remembers, organizes, and helps move the work
            forward.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row">
            <Link
              href="/signup"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-[#2B3624] px-6 py-3.5 text-sm font-medium text-[#F6F3EC] shadow-[0_2px_3px_-1px_rgba(0,0,0,0.12),0_0_0_1px_rgba(25,28,33,0.08)] transition-colors hover:bg-[#1F281A] sm:w-auto"
            >
              Start a free workspace
              <Icon icon="solar:arrow-right-linear" className="text-base" />
            </Link>
            <a
              href="#how-it-works"
              className="inline-flex w-full items-center justify-center gap-2 rounded-md border border-[#2B3624]/15 bg-white/40 px-6 py-3.5 text-sm font-medium text-[#2B3624] transition-colors hover:bg-white/70 sm:w-auto"
            >
              <Icon icon="solar:play-circle-linear" className="text-lg" />
              See how it works
            </a>
          </div>

          <div className="mt-6 flex gap-2 text-sm leading-relaxed text-[#66705F]">
            <Icon icon="solar:shield-check-linear" className="mt-0.5 shrink-0 text-base text-[#7C8D52]" />
            <p>Free for 14 days. No credit card required. Invite your team at no extra seat cost.</p>
          </div>
          <p className="mt-2 pl-6 text-xs font-medium text-[#8A9185]">
            Plans start at $20/month for up to 3 workspaces.
          </p>
        </div>

        <div className="relative xl:col-span-7">
          <HeroPreview />
        </div>
      </div>
    </section>
  );
}
